import React from 'react';
import { Box, Container, Grid, Link } from '@material-ui/core';
import { IAppDetailsView } from '../AppDetailsView';

export const AppDetailsAbout = ({ listing }: IAppDetailsView) => {
    return (
        <Box>
            <Container>
                <Box p={4}>
                    <Grid container spacing={4}>
                        <Grid sm={12} md={12} item>
                            <Box fontSize={'28px'} fontWeight={'300'}>
                                About the app
                            </Box>
                        </Grid>
                        <Grid>
                            <Box display={'flex'} flexDirection={'row'} ml={2}>
                                {listing.websiteUrl && (
                                    <Box mr={2}>
                                        <Link
                                            href={listing.websiteUrl}
                                            target={'_blank'}
                                            rel={'noreferrer'}
                                        >
                                            Website
                                        </Link>
                                    </Box>
                                )}
                                {listing.websiteUrl && listing.privacyPolicyUrl && (
                                    <span style={{ marginRight: 16 }}>/</span>
                                )}
                                {listing.privacyPolicyUrl && (
                                    <Box>
                                        <Link
                                            href={listing.privacyPolicyUrl}
                                            target={'_blank'}
                                            rel={'noreferrer'}
                                        >
                                            Privacy policy
                                        </Link>
                                    </Box>
                                )}
                            </Box>
                        </Grid>
                        <Grid item sm={12} md={12}>
                            <Box my={1} lineHeight={'26px'} style={{ maxWidth: 920, fontSize: 16 }}>
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: listing.description?.replaceAll('\n', '<br />'),
                                    }}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Container>
        </Box>
    );
};
